import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Grid, makeStyles } from '@material-ui/core';
import MailIcon from '@material-ui/icons/Mail';
import TenantConfigurationApi from '../../../core/apis/TenantConfigurationApi';
import useNotifyServerError from '../../../core/hooks/useNotifyServerError';
import UserApi from '../../../core/apis/UserApi';
import { useNotify } from 'react-admin';
import UserEmailDialog from '../UserEmailDialog';
import DialogContent from '@material-ui/core/DialogContent';

const useStyles = makeStyles({
  welcomeEmailDivStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingBottom: '20px'
  },
  welcomeEmailIcon: {
    color: '#2962FF'
  },
  welcomeEmailIconDisabled: {
    color: '#00000061'
  },
  labelStyle: {
    color: '#2962FF',
    marginLeft: '9px',
    cursor: 'pointer',
    paddingBottom: '2px'
  },
  labelStyleDisabled: {
    color: '#00000061',
    marginLeft: '9px',
    paddingBottom: '2px'
  },
  composeEmailStyle: {
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    marginTop: '18px'
  }
});

const EmailNotificationsStep = props => {
  const { permissions = [], contactCreated, connectedUserProfile } = props;
  const notify = useNotify();
  const classes = useStyles();
  const [welcomeEmailValue, setWelcomeEmailValue] = useState('');
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const isMupChild = sessionStorage.getItem('isMupChild') === 'true';
  const notifyServerError = useNotifyServerError();

  const [hasComposeEmailPermission] = useMemo(
    () => [permissions.includes('AUTH_COMPOSE_EMAIL')],
    [permissions]
  );

  const handleSendWelcomeEmailClick = async () => {
    if (isMupChild) {
      return;
    }
    try {
      await UserApi.sendWelcomeEmail(contactCreated.userId);
      notify('Welcome email sent');
    } catch (error) {
      notifyServerError(error, undefined);
    }
  };

  const fetchWelcomeEmailValue = useCallback(() => {
    TenantConfigurationApi.get('Welcome-Email-TemplateId')
      .then(response => setWelcomeEmailValue(response.pageData[0].value))
      .catch(error => notifyServerError(error, undefined));
  }, [notifyServerError]);

  useEffect(() => {
    fetchWelcomeEmailValue();
  }, [fetchWelcomeEmailValue]);

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {hasComposeEmailPermission && welcomeEmailValue !== '' && (
          <div
            id="send-mail"
            onClick={() => handleSendWelcomeEmailClick()}
            className={classes.welcomeEmailDivStyle}
          >
            <MailIcon
              className={
                isMupChild
                  ? classes.welcomeEmailIconDisabled
                  : classes.welcomeEmailIcon
              }
            />
            <label
              className={
                isMupChild ? classes.labelStyleDisabled : classes.labelStyle
              }
            >
              Send Welcome Email
            </label>
          </div>
        )}
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {hasComposeEmailPermission && (
          <Button
            variant="outlined"
            color="primary"
            id="compose-email"
            onClick={() => setOpenEmailModal(true)}
            className={classes.composeEmailStyle}
            disableFocusRipple
          >
            Compose Email
          </Button>
        )}
      </Grid>
      <DialogContent className={classes.dialogContent}>
        <UserEmailDialog
          open={openEmailModal}
          handleClose={() => setOpenEmailModal(false)}
          cc={contactCreated.ccEmailAddresses}
          userProfile={connectedUserProfile}
          record={contactCreated}
        />
      </DialogContent>
    </Grid>
  );
};

export default EmailNotificationsStep;
